import React, { useState } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Box from "@material-ui/core/Box";
import apiHelper from "../../../util/ApiHelper";
import { useLoading } from "../../../util/LoadingProvider";
import BannerTable from "./BannerTable";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: 0,
    // background: "#ffffff",
    paddingTop: "10px",
    paddingBottom: "10px",
    minHeight: "800px",
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
}));

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const typeMap = {
  0: "general",
  1: "homepage",
  2: "page",
};

function BannerListingPage(props) {
  const { disabled } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);
  const [onChange, setOnChange] = useState(true);
  const [status, setStatus] = useState(null);
  const [rows, setRows] = useState([]);
  const [queryString, setQueryString] = useState("");
  const [queryDate, setQueryDate] = React.useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [elementCounts, setElementCounts] = useState({
    all: 0,
    active: 0,
    inactive: 0,
  });

  // from child table
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);

  const { setLoading } = useLoading();

  const getBanners = React.useCallback(async () => {
    let dateValue = null;
    try {
      setLoading(true);

      if (queryDate) {
        const date = new Date(queryDate);
        let month = date.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        dateValue = date.getFullYear() + "-" + month + "-01";
      }
      
      const result = await apiHelper.hkiffApp.getHkiffAppBanners(
        typeMap[activeTab],
        null,
        pageIndex,
        (pageIndex + 1) * pageSize,
        pageSize,
        queryString,
        status
      );
      setRows(result.data.content.filter((x) => x));
      setTotalPages(result.data.totalPages);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [activeTab, status, pageIndex, pageSize, queryString, setLoading, queryDate]);

  React.useEffect(() => {
    async function refetchBannersOnChange() {
      let dateValue = null;
      setOnChange(false);
      try {
        const result = await apiHelper.hkiffApp.getHkiffAppBanners(
          typeMap[activeTab],
          null,
          0,
          0,
          9999999,
          queryString,
          dateValue
        );
        const all = result.data.totalElements;
        const active = result.data.content.filter(
          (x) => x && x.status === 1
        ).length;
        const inactive = result.data.content.filter(
          (x) => x && x.status === 0
        ).length;
        console.log({ all, active, inactive });
        setElementCounts({
          all,
          active,
          inactive,
        });
      } catch (error) {
        console.log(error);
      }
    }

    if (onChange) {
      refetchBannersOnChange();
    }
  }, [activeTab, onChange, queryString, queryDate]);

  React.useEffect(() => {
    getBanners();
  }, [getBanners]);

  return (
    <div className={classes.content}>
      <Typography variant="h4" gutterBottom>
        App Banner
      </Typography>
      <form>
          <BannerTable
            disabled={disabled}
            activeTab={activeTab}
            elementCounts={elementCounts}
            status={status}
            setStatus={setStatus}
            data={rows}
            setData={setRows}
            setOnChange={setOnChange}
            queryString={queryString}
            setQueryString={setQueryString}
            queryDate={queryDate}
            setQueryDate={setQueryDate}
            setParentPageIndex={setPageIndex}
            setParentPageSize={setPageSize}
            getBanners={getBanners}
            totalPages={totalPages}
          />
      </form>
    </div>
  );
}

export default BannerListingPage;
